import { FC } from "react";
import ReactPaginate from "react-paginate";

interface PaginationProps {
  onPageChange: (pageInfo: { selected: number; limit: number }) => void;
  count: number;
  page: number;
  limit: number;
  activeBgColor?: string;
  activeTextColor?: string;
}

const Pagination: FC<PaginationProps> = ({
  onPageChange,
  page,
  count,
  limit,
  activeBgColor = "#DE9C27",
  activeTextColor = "#ffffff",
}) => {
  const perPageOptions: number[] = [12, 10, 30, 50, 100];
  const handlePerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = parseInt(event.target.value, 10);
    if (value !== limit) {
      onPageChange({ selected: 0, limit: value });
    }
  };

  const handlePageChange = (pageInfo: { selected: number }) => {
    onPageChange({ ...pageInfo, limit });
  };

  return (
    <div className="w-full flex flex-wrap justify-between items-center py-4">
      <div className="flex items-center gap-4">
        <div className="w-20">
          <select
            name="limit"
            value={limit}
            onChange={handlePerPageChange}
            className="w-full h-10 border border-borderColor rounded px-2"
          >
            {perPageOptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        <span className="text-blackie text-sm">
          {count < (page + 1) * limit ? count : (page + 1) * limit} of {count}
        </span>
      </div>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageChange}
        pageRangeDisplayed={5}
        pageCount={Math.ceil(count / limit)}
        previousLabel="<"
        renderOnZeroPageCount={null}
        forcePage={page}
        containerClassName="flex list-none gap-2 flex-wrap"
        pageLinkClassName="px-3 py-2 text-blackie text-sm font-medium border border-borderColor rounded hover:bg-yellowBg"
        activeLinkClassName={`bg-yellowText text-[#ffffff]`}
        previousLinkClassName="px-3 py-2 text-blackie text-sm font-medium"
        nextLinkClassName="px-3 py-2 text-blackie text-sm font-medium"
      />
    </div>
  );
};

export default Pagination;
